<template>
  
  <div class="container">
  
    <Cabecera></Cabecera>
    <b-breadcrumb>
    <b-breadcrumb-item href="#"><router-link to="/">Inicio</router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/menuinicial">Inicio Usuario </router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/RegistrarPersonas">Registro de Personas</router-link></b-breadcrumb-item>
    
  </b-breadcrumb>
  <div>
  <Menu/>
    
  <b-card>
    
   <br>

        
          <span class="card-title">Registro de personas</span>
          <img id='Img2' src="../assets/credencial-1.png" height="200" alt="Image preview..." hidden=true>
          <form id="formPeso" autocomplete="off" @submit.prevent="editar" enctype="multipart/form-data">
            <input type="text" placeholder="Unidad" :value=unidad required disabled>
             <input type="date" name="fecharegistro" id="fecharegistro" placeholder="Fecha" v-on:click=usuario() required>
             <input type="text" name="nombre" id="nombre" placeholder="Nombre del titular" required>
             <input type="text" name="apellidos" id="apellidos" placeholder="Apellidos del titular" required>

             <b-form-select v-model="selected2" class="mb-3" required>
                <template v-slot:first>
        <b-form-select-option :value="null" disabled  >-- Selecciona el tipo --</b-form-select-option>
      </template>
      <b-form-select-option value="Introductor">Introductor</b-form-select-option>
      <b-form-select-option value="Cliente">Cliente</b-form-select-option>
      <b-form-select-option value="Proveedor">Proveedor</b-form-select-option>
      <b-form-select-option value="Trabajador de Introductor">Trabajador de Introductor</b-form-select-option>
      <b-form-select-option value="Chofer">Chofer</b-form-select-option>
      <b-form-select-option value="Visita">Visita</b-form-select-option>
     
    </b-form-select>

    <input type="text" name="otro" id="otro" placeholder="Otro tipo">
    <input type="text" name="respaldo" id="respaldo" placeholder="Persona que respalda" required>
    
    <b-form-checkbox-group
      v-model="selected"
      :options="options"
      class="mb-3"
      value-field="item"
      text-field="name"
      disabled-field="notEnabled"
    ></b-form-checkbox-group>

    <input type="hidden" name="dias" id="dias" placeholder="dias" v-model="selected">
    
    Hora de entrada (00:00 am/pm)<input type="time" name="horaentrada" id="horaentrada" placeholder="Hora de entrada autorizada" required>
    Hora de salida (00:00 am/pm)<input type="time" name="horasalida" id="horasalida" placeholder="Hora de salida autorizada" required>
    <input type="text" name="area" id="area" placeholder="Área autorizada" required>
    <input type="text" name="gafete" id="gafete" placeholder="Clave distintivo" required>
    <input type="text" name="telefono" id="telefono" placeholder="Teléfono de contacto" required>
    <input type="text" name="comentarios" id="comentarios" placeholder="Comentarios">
        
       <div class="file-field input-field">
                <div class="btn">
                <span>Fotografía</span>
                <input type="file" name="foto">
                </div>
                <div class="file-path-wrapper">
                <input class="file-path validate" type="text">
                </div>
            </div>      

            <input type="hidden" name="unidadForma" id="unidadForma" :value=unidad> 
             <input type="hidden" name="usuarioForma" id="usuarioForma" :value=usuariolocal>
             <input type="hidden" name="tipo" id="tipo" :value=selected2>
             <input type="hidden" name="idForma" id="idForma" :value=idActual>
             <input type="hidden" name="seccionForma" id="seccionForma" :value=seccion>
             <input type="hidden" name="distintivo" id="distintivo" :value=qrDistintivo>
             <input type="hidden" name="apellidosdistintivo" id="apellidosdistintivo" :value=qrapellidos>
             <input type="hidden" name="nombredistintivo" id="nombredistintivo" :value=qrnombre>
             <input type="hidden" name="telefonodistintivo" id="telefonodistintivo" :value=qrtelefono>
            <input type="hidden" name="perfildistintivo" id="perfildistintivo" :value=qrperfil>
            
<div class="card-action">

                        <input type="submit" value="Registrar" class="btn btn-outline-success" required >
                           
        </div>
            </form>
       
    <b-card-body class="text-center">
      <b-card-title>Pantalla de inicio</b-card-title>

      <b-card-text>
       <div>
    <h5>Listado del día <input width="4" type="date" name="fechadia" id="fechadia" placeholder="Fecha" v-on:click=ajax() >
<p id="datetime"></p>
    </h5>
   <vue-good-table
   :columns="columns"
     :rows="rows"
     @on-cell-click="onCellClick2"
     
     :pagination-options="{
       enabled:true,
      
       mode:'remote',
       perPage:350,
       position:'top',
       perPageDropdown:[10,50,100],
       nextLabel:'Siguiente',
       PrevLabel:'Anterior',
       rowsPerPageLabel:'Filas por página',
       ofLabel:'de'
     }"
     :search-options="{
       enabled:true,
       trigger:'enter',
       placeholder:'Buscar'
     }"
   >
     <template slot="table-row" slot-scope="props">
          
    <span v-if="props.column.field == 'eliminar'">
       <b-button variant="outline-danger">Eliminar</b-button>
    </span>
    <span v-else-if="props.column.field == 'codigo'">
       <qrcode-vue class='codigoQR' :value="'https://micomidasegura.mx/#/registrarFlujoQR/'+props.formattedRow['gafete']" :size="size" level="H" renderAs='canvas' background='#ffffff' foreground='#000000'></qrcode-vue>
    </span>
    <span v-else-if="props.column.field == 'pdf'">
       <b-button variant="outline-danger">Exportar</b-button>
    </span>
    <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>
  </template>
   </vue-good-table>
</div>
      </b-card-text>

      <b-button variant="primary">Go somewhere</b-button>
    </b-card-body>
  </b-card>
</div>

    
  </div>
</template>

<script>
import Cabecera from './Cabecera' //v-on:keyup.enter="onEnter"
import Menu from './Menu'
import axios from 'axios'
import swal from 'sweetalert'
import sesion from '../mixins/sesion'
import QrcodeVue from 'qrcode.vue'

import qrCode from 'qrcode'
import jsPDF from 'jspdf'
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'
import eliminarDecomisos from '../mixins/eliminarDecomisos'
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
export default {
  name: 'RegistrarPersonas',  
  data () {
    return {
        value:null,
      msg: 'Número de arete',
      inventarioCanales:{},
      usuariolocal:'',
      fotolocal:'',
      unidad:'',
        fecha1:'',
        fecha2:'',
        serie:'',
        canal:'',
        seccion:'',
        qrText: 'hola',
      qrSrc: null,
      blob2:null,
      qrDistintivo:'hola',
      qrapellidos:'hola',
      qrnombre:'hola',
      qrtelefono:'hola',
      qrperfil:'hola',
       size:100,
        canvas:'',
        context:'',
        img:'',
        //value: 'https://example.com',
selected: [],
        options: [
          { item: '2', name: 'Lunes' },
          { item: '3', name: 'Martes' },
          { item: '4', name: 'Miércoles' },
          { item: '5', name: 'Jueves' },
          { item: '6', name: 'Viernes' },
          { item: '7', name: 'Sábado' },
          { item: '1', name: 'Domingo' },
        ],
selected2: null,
selectedCanal:null,
diasautorizados:null,
//Datos del checkbox
      columns:[
        {
          label:'Gafete',
          field:'gafete'
        },
        {
          label:'Id',
          field:'id',
          hidden: true
        },
        {
          label:'Nombre',
          field:'nombre'
        },
        {
          label:'Apellidos',
          field:'apellidos'
        },
        {
          label:'Código',
          field:'codigo',
        },
        {
          label:'PDF',
          field:'pdf',
        },
        {
          label:'Eliminar',
          field:'eliminar',
        },
      ],
      rows:[

      ],

      
    }
    },
  
  computed:{
      ...mapState(['usuarioActual','idActual','fotoActual'])
  },
  methods:{
    createObjectUrl (err, canvas) {
        var file    = document.querySelector('input[type=file]').files[0];
        
      if (!err) {
        canvas.toBlob((blob) => {
          this.qrSrc = window.URL.createObjectURL(blob)
         this.blob2=blob
         console.log(this.blob2.type +'sí se pudo')
         console.log(blob.type +'sí se pudo')
      let link = document.createElement('a');
        link.download = 'hello.png';
         let reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = function() {
        link.href = reader.result; // data url
        
        var c=document.createElement('canvas')
var img = document.getElementById('Img2')
c.height=img.naturalHeight
c.width=img.naturalWidth
var ctx = c.getContext('2d')
console.log(img+'sí se pudo img34')
ctx.drawImage(img,0,0,c.width,c.height)
var base64String=c.toDataURL()
       
         var doc = new jsPDF({
 //orientation: 'landscape',
  unit: 'mm',
  //format: [80, 40]
  format: 'letter'
})


doc.addImage(base64String, 'PNG', 0, 0,144,120) //imagen distintivo

doc.setDrawColor(255, 255,255)
doc.setFillColor(255, 255, 255)
doc.roundedRect(90, 14, 30, 8, 3, 3, 'FD')//telefono
doc.roundedRect(110, 69, 30, 8, 3, 3, 'FD')//cuadro qr 2
doc.roundedRect(40, 65, 30, 15, 3, 3, 'FD')//cuadro distintivo
doc.roundedRect(5, 87, 20, 20, 3, 3, 'FD')
doc.roundedRect(5, 43, 60, 27, 3, 3, 'FD')//cuadro nombre
doc.roundedRect(80, 43, 60, 27, 3, 3, 'FD')//cuadro nombre
doc.setFontSize(25)
doc.setTextColor(255, 0, 0)
doc.text(document.getElementById('distintivo').value,38,75)

doc.text(document.getElementById('distintivo').value,110,75)
doc.setFontSize(15)
doc.text(document.getElementById('nombredistintivo').value,10,50)
doc.text(document.getElementById('apellidosdistintivo').value,10,56)
doc.text(document.getElementById('perfildistintivo').value,10,63)
doc.text(document.getElementById('telefonodistintivo').value,90,20)
doc.addImage(link.href, 'PNG', 30, 5, 40, 40) //codigoqr
doc.addImage(link.href, 'PNG', 117, 75, 22, 22) //codigoqr

doc.save('two-by-four.pdf')
       // link.click();
        }
       
        })
        } else {
        console.warn('generateQrCode:ERROR', err)
      }
 
      
    },
    generateQrCode () {
      if (!this.qrText) { return }
      //document.URL.revokeObjectURL(this.qrSrc)
     window.URL.revokeObjectURL(this.qrSrc)
      qrCode.toCanvas(this.qrText, {}, this.createObjectUrl)
    },
      setDia(){
          this.dias=selected
      },
      
    getId(){
           this.usuario()

            const id = document.getElementById("usuarioForma").value
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getPerfilUsuario.php?id='+ id)
            
                .then(response=>{
                   
                    this.unidad = response.data.unidad
                    this.usuariolocal=response.data.email
                    
                })        
        },

    
  onCellClick2(params) {
         if(params.column.field=="eliminar"){   //que sea solo en esas columnas y que se refresque
         this.serie=params.row.serie
         this.canal=params.row.id
         this.seccion=params.row.seccion
         
         swal({
            title:'Seguro que deseas eliminar el registro',
            text:'',
            icon:'warning',
            buttons:true,
            dangerMode:true,
        })
        .then((aceptar)=>{
            if(aceptar){
            const form=params.row.id
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/eliminarRegistroPersona.php?id=' + form)
                .then(res=>{
                    this.respuesta = res.data
                    if (res.data == 'success') {
                        this.ajax()
         
                      swal('Se registro fue eliminado')
                       //location.reload()
                        //this.$router.push('/inicio')
                    } else {
                        swal('El registro no fue eliminado')
                    }
                })
            }else{
                return false;
            }
        })
         this.ajax()
        
         
         }
         if(params.column.field=="pdf"){
           this.qrDistintivo=params.row.gafete
           this.qrnombre=params.row.nombre
           this.qrapellidos=params.row.apellidos
           this.qrtelefono=params.row.telefono
           this.qrperfil=params.row.tipo
           this.qrText='https://micomidasegura.mx/#/registrarFlujoQR/'+params.row.gafete
          
           this.generateQrCode()
           //swal('https://micomidasegura.mx/#/registrarFlujoQR/'+params.row.gafete)
          
         }
  },
      /*onEnter: function() {
      swal("Mensaje de enter")
    },*/
    fecha(){
        var dt = new Date();
    document.getElementById("datetime").innerHTML = ((dt.getFullYear() +"-"+ (("0"+(dt.getMonth()+1)).slice(-2)) 
    +"-"+ ("0"+dt.getDate()).slice(-2)));
    },
    ajax(){
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     this.getId()
    const fecha = document.getElementById("fechadia").value
     const unidadquery=this.unidad
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getPersonas.php?unidad='+unidadquery)
      .then(response=>{
        this.rows=response.data
      })

    },

    
    usuario(){
        this.fecha()
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     var yourString = this.$localStorage.get('token');
     var result = yourString.slice(1,-1);
     //this.usuariolocal= result
     //const tok=this.usuariolocal
     const tok=result
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getUserData2.php?token='+tok)
      .then(response=>{
       
        this.usuariolocal=response.data.email
        this.unidad=response.data.unidad
        this.perfil=response.data.perfil
      })

    },
    ticketIncremento(){
       // document.getElementById('canal').value=document.getElementById('canal').value++
    this.value=Number(this.value)+1
    },
    editar(){
        
        this.getId()
        
           
            this.usuario()
            
             const form=document.getElementById('formPeso')
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/registrarPersonas.php',new FormData(form))
                .then(res=>{
                    this.respuesta = res.data
                    if (res.data == 'success') {
                       // this.ticketIncremento()
                      
                       swal('Se registro la persona con éxito'+res.data)
                       //location.reload()
                        //this.$router.push('/inicio')
                        
                    } else {
                        swal('La persona no pudo ser registrado'+res.data)
                    }
                })
        },
        direccionamiento(){
            if (this.respuesta=='success') {
                this.$router.push('/')
            } else {
                swal({
                    title:'No se pudo registrar',
                    icon: 'error'})  
            }
        },
  },
  created(){
    this.ajax()
    this.usuario()
   

  },
  components:{
     
    Cabecera,
    Menu,
     QrcodeVue,
     QrcodeStream, 
    QrcodeDropZone, 
    QrcodeCapture 

  },
  mixins:[sesion,eliminarDecomisos]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RegistrarPersonas.vue